import { AngleIron } from '@App/app/entities/layer/angle-iron.model';
import { ANGLE_IRON_STRICT } from '@App/app/entities/layer/enums/layer-types.enum';
import { LayerUI } from '@App/app/entities/layer/layer-ui.model';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { addLayer } from 'src/app/pages/viewer/store/actions/layers.actions';
import { UtilsService } from '../../utils-service/utils.service';
import { AngleIronGeometryService } from './angle-iron-geometry.service';
import { AngleIronSampleService } from './angle-iron-sample.service';

@Injectable({
  providedIn: 'root',
})
export class CreateAngleIronService {
  get activePart() {
    return this.sampleService.activePart;
  }
  set activePart(value: ANGLE_IRON_STRICT | null) {
    this.sampleService.activePart = value;
  }

  get highlightedSample() {
    return this.sampleService.highlightedSample;
  }

  get samples() {
    return this.sampleService.samples;
  }

  get angleIronDataChange$() {
    return this.sampleService.angleIronDataChange$;
  }

  constructor(
    private sampleService: AngleIronSampleService,
    private geometryService: AngleIronGeometryService,
    private store: Store,
    private utilsService: UtilsService,
  ) {}

  onClickAction() {
    const hit = this.utilsService.pickRay();
    if (hit?.pickedMesh && hit.pickedPoint) {
      this.sampleService.createSamplePoint(hit.pickedPoint.clone());
      this.sampleService.notifyChange();
    }
  }

  createAngleIron() {
    try {
      const { planes, innerSamples } = this.sampleService.buildPlanesFromSamples();
      const { boxes, quaternion, length } = this.geometryService.calculateAngleIronData(
        innerSamples,
        planes,
      );
      const angleIron = new AngleIron();
      angleIron.name = `angleIron`;
      angleIron.isVisible = true;
      angleIron.isSaved = true;
      angleIron.data.absoluteRotationQuaternion = {
        x: quaternion.x,
        y: quaternion.y,
        z: quaternion.z,
        w: quaternion.w,
      };
      angleIron.data.boxes = [
        {
          min: { x: boxes[0].min.x, y: boxes[0].min.y, z: boxes[0].min.z },
          max: { x: boxes[0].max.x, y: boxes[0].max.y, z: boxes[0].max.z },
        },
        {
          min: { x: boxes[1].min.x, y: boxes[1].min.y, z: boxes[1].min.z },
          max: { x: boxes[1].max.x, y: boxes[1].max.y, z: boxes[1].max.z },
        },
      ];
      angleIron.data.length = +length.toFixed(5);
      this.store.dispatch(addLayer({ layer: angleIron as LayerUI, commit: false }));
    } catch (err) {
      this.utilsService.catchToolCreationError(err);
      this.clear();
    }
  }

  deleteSamplePoint(part: ANGLE_IRON_STRICT, i: number) {
    this.sampleService.deleteSamplePoint(part, i);
  }

  highlightSample(part: ANGLE_IRON_STRICT, i: number) {
    this.sampleService.highlightSample(part, i);
  }

  setActivePart(part: ANGLE_IRON_STRICT) {
    this.sampleService.setActivePart(part);
  }

  clear() {
    this.sampleService.clear();
  }
}
